"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollPosition = exports.ScrollProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _scrollPosition = _interopRequireDefault(require("./scroll-position"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ScrollContext = /*#__PURE__*/(0, _react.createContext)(0);

/**
 * ScrollProvider component
 *
 * @param {Object} props React props.
 * @param {React.ReactNode} children Child components.
 * @returns {JSX.Element} ScrollProvider component.
 */

const ScrollProvider = ({
  children
}) => {
  const {
    scrollY,
    scrollDirection
  } = (0, _scrollPosition.default)();
  return /*#__PURE__*/_react.default.createElement(ScrollContext.Provider, {
    value: {
      scrollY,
      scrollDirection
    }
  }, children);
};
exports.ScrollProvider = ScrollProvider;
ScrollProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};

/**
 * Custom hook to consume scroll position from ScrollContext.
 *
 * @returns {number} The current vertical scroll position (`scrollY`).
 */
const useScrollPosition = () => {
  return (0, _react.useContext)(ScrollContext);
};
exports.useScrollPosition = useScrollPosition;